import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";

// Shared layout wrapper for static/legal pages.
export default function PageShell({
  eyebrow,
  title,
  subtitle,
  children,
  testId,
}) {
  return (
    <main
      data-testid={testId}
      className="relative bg-[#0F172A] text-white min-h-screen overflow-hidden"
    >
      <Nav />

      {/* ambient glow */}
      <div
        aria-hidden
        className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(0,250,248,0.10), transparent 60%)",
          filter: "blur(30px)",
        }}
      />

      <section className="relative pt-36 md:pt-44 pb-16 md:pb-20">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">
          <Link
            to="/"
            data-testid="page-back"
            className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-[#00FAF8] bp-link mb-10"
          >
            <ChevronLeft size={16} />
            Zurück zur Startseite
          </Link>

          <div className="flex items-center gap-4 mb-8">
            <span className="font-mono-bp text-[11px] tracking-[0.35em] uppercase text-[#00FAF8]">
              {eyebrow}
            </span>
            <span className="flex-1 h-px bg-gradient-to-r from-[#00FAF8]/40 via-white/10 to-transparent" />
          </div>

          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-[-0.03em] font-medium"
          >
            {title}
          </motion.h1>

          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.8 }}
              className="mt-6 text-lg text-white/60 leading-relaxed max-w-2xl"
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </section>

      <section className="relative pb-24 md:pb-32">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10">{children}</div>
      </section>

      <Footer />
    </main>
  );
}
